module.exports = [{
      plugin: require('/workspace/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["PT Serif"]},"custom":{"families":["Inter"],"urls":["/fonts/fonts.css"]}},
    },{
      plugin: require('/workspace/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
